import { memo } from 'react';
import { IconWrapper } from './IconWrapper';

export const CalcIcon = memo(() => (
    <IconWrapper>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fill="currentColor"
                // eslint-disable-next-line max-len
                d="M8.4 17.6h.7v-2h2v-.7h-2v-2h-.7v2h-2v.7h2v2Zm5-.75h4.2v-.7h-4.2v.7Zm0-2.5h4.2v-.7h-4.2v.7ZM6.65 8.8h4.2v-.7h-4.2v.7ZM4.3 19.7V4.3h15.4v15.4H4.3ZM5 19h14V5H5v14Zm9.1-8.65 1.4-1.4 1.4 1.4.5-.5-1.4-1.4 1.4-1.4-.5-.5-1.4 1.4-1.4-1.4-.5.5 1.4 1.4-1.4 1.4.5.5Z"
            />
        </svg>
    </IconWrapper>
));
